import React from "react";
import { FiEye } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { Badge, UncontrolledTooltip } from "reactstrap";

import ReportTable from "components/Report";
import { stringToMask } from "helpers/string";

import { formatPartner, getStatusMeta } from "../../constants";
import {
	ActionButton,
	ActionContent,
	CellStack,
	EmptyValue,
	LinkText,
	PartnerName,
	StatusContent,
	TableVisualWrapper
} from "./styles";

const BenefitStatus = ({ benefit }) => {
	const meta = getStatusMeta(benefit?.status);

	return (
		<StatusContent>
			<Badge style={{ backgroundColor: meta.color }} className="w-100">
				{meta.label.toUpperCase()}
			</Badge>
			<PartnerName>{formatPartner(benefit?.partner)}</PartnerName>
		</StatusContent>
	);
};

const InsuredUsersTable = ({
	items,
	count,
	pages,
	loading,
	tableRef,
	onFetchData,
	onOpenDetails
}) => {
	const history = useHistory();

	const columns = [
		{
			Header: "Prestador",
			id: "name",
			accessor: row => (
				<CellStack>
					{row._id ? (
						<>
							<LinkText
								id={`benefit-name-${row._id}`}
								onClick={() => history.push(`/client/${row._id}`)}
							>
								{row.name?.trim() || "—"}
							</LinkText>
							<UncontrolledTooltip target={`benefit-name-${row._id}`}>
								Ver detalhes do prestador
							</UncontrolledTooltip>
						</>
					) : (
						<strong>{row.name?.trim() || "—"}</strong>
					)}
					<span>
						CPF {row.cpf ? stringToMask(row.cpf, "###.###.###-##") : "—"}
					</span>
				</CellStack>
			),
			minWidth: 210
		},
		{
			Header: "Contratante",
			id: "company",
			accessor: row =>
				row.company ? (
					<CellStack>
						{row.company._id ? (
							<>
								<LinkText
									id={`benefit-company-${row.company._id}`}
									onClick={() => history.push(`/companies/${row.company._id}`)}
								>
									{row.company.name || "—"}
								</LinkText>
								<UncontrolledTooltip
									target={`benefit-company-${row.company._id}`}
								>
									Ver detalhes da contratante
								</UncontrolledTooltip>
							</>
						) : (
							<strong>{row.company.name || "—"}</strong>
						)}
						<span>
							{row.company.cnpj
								? stringToMask(row.company.cnpj, "##.###.###/####-##")
								: "—"}
						</span>
					</CellStack>
				) : (
					<EmptyValue>—</EmptyValue>
				),
			minWidth: 210,
			sortable: false
		},
		{
			Header: "Seguro de Vida",
			id: "lifeInsuranceStatus",
			accessor: row => <BenefitStatus benefit={row.lifeInsurance} />,
			width: 145
		},
		{
			Header: "DIT",
			id: "ditStatus",
			accessor: row => <BenefitStatus benefit={row.dit} />,
			width: 145
		},
		{
			Header: "Acionamentos",
			id: "triggers",
			accessor: row => row.triggers || 0,
			width: 115,
			sortable: false
		},
		{
			Header: "Última observação",
			id: "lastObservation",
			accessor: row => row.lastObservation || <EmptyValue>—</EmptyValue>,
			minWidth: 220,
			sortable: false
		},
		{
			Header: "Ações",
			id: "actions",
			accessor: row => (
				<ActionContent>
					<ActionButton
						type="button"
						id={`benefit-action-${row._id}`}
						onClick={event => {
							event.preventDefault();
							event.stopPropagation();
							onOpenDetails(row);
						}}
						aria-label={`Atualizar benefícios de ${row.name || "prestador"}`}
					>
						<FiEye size={24} />
					</ActionButton>
					{row._id && (
						<UncontrolledTooltip target={`benefit-action-${row._id}`}>
							Atualizar benefícios do prestador
						</UncontrolledTooltip>
					)}
				</ActionContent>
			),
			width: 75,
			sortable: false
		}
	];

	return (
		<TableVisualWrapper>
			<ReportTable
				manual
				noTitle
				noExport
				tableRef={tableRef}
				count={count}
				data={items}
				pages={pages}
				loading={loading}
				filterable={false}
				defaultPageSize={10}
				pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
				onFetchData={onFetchData}
				columns={columns}
			/>
		</TableVisualWrapper>
	);
};

export default InsuredUsersTable;
